const DEFAULT_URL = '/ui-texts.ru.json';
const RUNTIME_URL = '/api/v1/ui-texts';

const state = {
  defaults: {},
  overrides: {},
  strings: {},
  revision: 0,
  locale: 'ru',
};

let readyPromise = null;

const interpolate = (value, params = {}) => String(value ?? '').replace(/\{([a-zA-Z0-9_]+)\}/g, (_, key) => (
  Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : `{${key}}`
));

async function json(url) {
  const response = await fetch(url, {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
}

function merge() {
  state.strings = { ...state.defaults, ...state.overrides };
}

export function t(key, params = {}) {
  const value = Object.prototype.hasOwnProperty.call(state.strings, key) ? state.strings[key] : key;
  return interpolate(value, params);
}

export function applyI18n(root = document) {
  root.querySelectorAll?.('[data-ui-text]').forEach((node) => {
    node.textContent = t(node.dataset.uiText);
  });
  root.querySelectorAll?.('[data-ui-text-placeholder]').forEach((node) => {
    node.setAttribute('placeholder', t(node.dataset.uiTextPlaceholder));
  });
  root.querySelectorAll?.('[data-ui-text-title]').forEach((node) => {
    node.setAttribute('title', t(node.dataset.uiTextTitle));
  });
  root.querySelectorAll?.('[data-ui-text-aria]').forEach((node) => {
    node.setAttribute('aria-label', t(node.dataset.uiTextAria));
  });
  const description = document.querySelector('meta[name="description"]');
  if (description) description.setAttribute('content', t('meta.description'));
}

async function load() {
  const base = await json(DEFAULT_URL);
  state.defaults = base?.strings || {};
  try {
    const runtime = await json(RUNTIME_URL);
    state.overrides = runtime?.data?.strings || {};
    state.revision = Number(runtime?.data?.revision || 0);
    state.locale = runtime?.data?.locale || base?.locale || 'ru';
  } catch (error) {
    console.warn('ui text runtime dictionary is unavailable; using bundled dictionary', error);
    state.overrides = {};
    state.revision = 0;
    state.locale = base?.locale || 'ru';
  }
  merge();
  applyI18n(document);
  return getI18nSnapshot();
}

export function initializeI18n() {
  if (!readyPromise) readyPromise = load();
  return readyPromise;
}

export function i18nReady() {
  return initializeI18n();
}

export async function reloadI18n() {
  readyPromise = load();
  await readyPromise;
  applyI18n(document);
  window.dispatchEvent(new CustomEvent('kuni:ui-texts-reloaded', { detail: { revision: state.revision } }));
  return getI18nSnapshot();
}

export function replaceI18nOverrides(strings, revision = state.revision) {
  state.overrides = { ...(strings || {}) };
  state.revision = Number(revision || 0);
  merge();
  applyI18n(document);
  window.dispatchEvent(new CustomEvent('kuni:ui-texts-reloaded', { detail: { revision: state.revision } }));
}

export function getI18nSnapshot() {
  return {
    defaults: { ...state.defaults },
    overrides: { ...state.overrides },
    strings: { ...state.strings },
    revision: state.revision,
    locale: state.locale,
  };
}

export function getDefaultStrings() {
  return { ...state.defaults };
}
